module.exports = __webpack_public_path__ + "img/050_basis.14686cf0.jpg";